import i18n from "i18next";
import { initReactI18next } from "react-i18next";

void i18n.use(initReactI18next).init({
  fallbackLng: "en_US",
  lng: "en_US",
  resources: {
    en: {
      translations: require("./locales/en.json"),
    },
    sr: {
      translations: require("./locales/sr.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: ".",
  returnNull: false,
});

i18n.languages = ["en_US", "sr_Latn_RS"];

export default i18n;
